import React, { useState as useReactState, useRef, useEffect } from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@pagespeedify/ui';
import { LogOutIcon as LogOut } from '@pagespeedify/ui';
import { User } from '../lib/auth/types';

export const UserAvatarDropdown: React.FC<{ user: User, onLogout: () => void }> = ({ user, onLogout }) => {
  const [open, setOpen] = useReactState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Close dropdown on outside click
  useEffect(() => {
    if (!open) return;
    function handleClick(e: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        className="focus:outline-none"
        onClick={() => setOpen((v) => !v)}
        aria-label="User menu"
        tabIndex={0}
      >
        <Avatar className="h-8 w-8 bg-blue-600 shadow-[0_0_0_2px_rgba(59,130,246,0.5),0_0_8px_2px_rgba(59,130,246,0.4)] hover:scale-105 transition-transform">
          {user.photoURL ? (
            <AvatarImage src={user.photoURL} alt={user.email || 'User'} />
          ) : (
            <AvatarFallback>{user.email ? user.email[0]?.toUpperCase() : 'U'}</AvatarFallback>
          )}
        </Avatar>
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-40 bg-popover border border-border rounded-lg shadow-lg py-2 z-[9999] animate-fade-in">
          <div className="px-4 py-2 text-xs text-muted-foreground break-all">{user.email}</div>
          <button
            className="w-full text-left px-4 py-2 text-sm hover:bg-muted transition-colors"
            onClick={() => { setOpen(false); onLogout(); }}
          >
            <LogOut className="inline mr-2 h-4 w-4" />Logout
          </button>
        </div>
      )}
    </div>
  );
};
